import * as firebase from 'firebase';
import 'firebase/firestore';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDDuwBibYGhRS3Hopov7LDEF3yQl3U-uXc",
    authDomain: "food-fights.firebaseapp.com",
    databaseURL: "https://food-fights.firebaseio.com",
    projectId: "food-fights",
    storageBucket: "food-fights.appspot.com",
    messagingSenderId: "424793875428"
});

const auth = firebaseApp.auth(); 
const db = firebaseApp.firestore();

export { db, auth };


// WEBPACK FOOTER //
// ./src/util/firebase.js